import { render, staticRenderFns } from "./ListOfPeople.vue?vue&type=template&id=2efb6913&lang=pug"
import script from "./ListOfPeople.vue?vue&type=script&lang=js"
export * from "./ListOfPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports